var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16.495,
  height: 18.332,
  viewBox: "0 0 16.495 18.332"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-user",
  "data-name": "Icon feather-user",
  transform: "translate(-5.1 -3.6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M20.7,28.011V26.174A3.674,3.674,0,0,0,17.021,22.5H9.674A3.674,3.674,0,0,0,6,26.174v1.837",
  transform: "translate(0 -6.979)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M19.348,8.174A3.674,3.674,0,1,1,15.674,4.5,3.674,3.674,0,0,1,19.348,8.174Z",
  transform: "translate(-2.326)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8
}))));
export { SvgContactsIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/contactsIcon.62e228ac976422f7d4e1906869e11c62.svg";